export default class ContactPerson {

    constructor(data) {
        this.id = null;
        this.title = null;
        this.firstname = null;
        this.lastname = null;
        this.birthday = null;
        this.note = null;
        this.street = null;
        this.zipcode = null;
        this.city = null;
        this.phone = null;
        this.mobile = null;
        this.fax = null;
        this.email = null;
        this.privatePhone = null;
        this.privateMobile = null;
        this.privateFax = null;
        this.privateEmail = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/contactperson.model.js